window.sticker250Price = [
  {
    "1x1": 37.5,
  },
  {
    "1x2": 45,
  },
  {
    "1x3": 45,
  },
  {
    "1x4": 50,
  },
  {
    "1x5": 55,
  },
  {
    "1x6": 60,
  },
  {
    "1x7": 65,
  },
  {
    "1x8": 70,
  },
  {
    "1x9": 75,
  },
  {
    "1x10": 80,
  },
  {
    "1x11": 85,
  },
  {
    "1x12": 90,
  },
  {
    "2x1": 42.5,
  },
  {
    "2x2": 52.5,
  },
  {
    "2x3": 62.5,
  },
  {
    "2x4": 72.5,
  },
  {
    "2x5": 82.5,
  },
  {
    "2x6": 92.5,
  },
  {
    "2x7": 102.5,
  },
  {
    "2x8": 112.5,
  },
  {
    "2x9": 122.5,
  },
  {
    "2x10": 132.5,
  },
  {
    "2x11": 142.5,
  },
  {
    "2x12": 152.5,
  },
  {
    "3x1": 50,
  },
  {
    "3x2": 57.5,
  },
  {
    "3x3": 75,
  },
  {
    "2.75x2.15": 75,
  },
  {
    "3x4": 87.5,
  },
  {
    "3x5": 100,
  },
  {
    "3x6": 110,
  },
  {
    "3x7": 120,
  },
  {
    "3x8": 135,
  },
  {
    "3x9": 150,
  },
  {
    "3x10": 160,
  },
  {
    "3x11": 170,
  },
  {
    "3x12": 180,
  },
  {
    "3.68x2.24": 90,
  },
  {
    "4x1": 60,
  },
  {
    "4x2": 80,
  },
  {
    "3.5x2.5": 90,
  },
  {
    "4x3": 90,
  },
  {
    "4x4": 110,
  },
  {
    "4x5": 125,
  },
  {
    "4x6": 135,
  },
  {
    "4x7": 150,
  },
  {
    "4x8": 165,
  },
  {
    "4x9": 180,
  },
  {
    "4x10": 190,
  },
  {
    "4x11": 200,
  },
  {
    "4x12": 225,
  },
  {
    "5x1": 115,
  },
  {
    "5x2": 135,
  },
  {
    "5x3": 110,
  },
  {
    "5x4": 125,
  },
  {
    "5x5": 140,
  },
  {
    "5x6": 160,
  },
  {
    "5x7": 175,
  },
  {
    "5x8": 190,
  },
  {
    "5x9": 210,
  },
  {
    "5x10": 225,
  },
  {
    "5x11": 240,
  },
  {
    "5x12": 250,
  },
  {
    "6x1": 60,
  },
  {
    "6x2": 90,
  },
  {
    "6x3": 115,
  },
  {
    "6x4": 125,
  },
  {
    "6x5": 160,
  },
  {
    "6x6": 180,
  },
  {
    "6x7": 200,
  },
  {
    "6x8": 215,
  },
  {
    "6x9": 235,
  },
  {
    "6x10": 250,
  },
  {
    "6x11": 265,
  },
  {
    "6x12": 280,
  },
  {
    "7x1": 75,
  },
  {
    "7x2": 100,
  },
  {
    "7x3": 130,
  },
  {
    "7x4": 150,
  },
  {
    "7x5": 175,
  },
  {
    "7x6": 200,
  },
  {
    "7x7": 220,
  },
  {
    "7x8": 240,
  },
  {
    "7x9": 260,
  },
  {
    "7x10": 285,
  },
  {
    "7x11": 300,
  },
  {
    "7x12": 320,
  },
];
window.sticker500Price = [
  {
    "1x1": 65,
  },
  {
    "1x2": 70,
  },
  {
    "1x3": 80,
  },
  {
    "1x4": 90,
  },
  {
    "1x5": 100,
  },
  {
    "1x6": 110,
  },
  {
    "1x7": 120,
  },
  {
    "1x8": 130,
  },
  {
    "1x9": 140,
  },
  {
    "1x10": 150,
  },
  {
    "1x11": 160,
  },
  {
    "1x12": 170,
  },
  {
    "2x1": 75,
  },
  {
    "2x2": 95,
  },
  {
    "2x3": 115,
  },
  {
    "2x4": 135,
  },
  {
    "2x5": 155,
  },
  {
    "2x6": 175,
  },
  {
    "2x7": 195,
  },
  {
    "2x8": 215,
  },
  {
    "2x9": 235,
  },
  {
    "2x10": 255,
  },
  {
    "2x11": 275,
  },
  {
    "2x12": 295,
  },
  {
    "3x1": 90,
  },
  {
    "3x2": 115,
  },
  {
    "3x3": 140,
  },
  {
    "2.75x2.15": 140,
  },
  {
    "3x4": 165,
  },
  {
    "3x5": 190,
  },
  {
    "3x6": 210,
  },
  {
    "3x7": 230,
  },
  {
    "3x8": 255,
  },
  {
    "3x9": 275,
  },
  {
    "3x10": 295,
  },
  {
    "3x11": 315,
  },
  {
    "3x12": 335,
  },
  {
    "4x1": 100,
  },
  {
    "4x2": 135,
  },
  {
    "3.5x2.5": 165,
  },
  {
    "3.68x2.24": 165,
  },
  {
    "4x3": 165,
  },
  {
    "4x4": 200,
  },
  {
    "4x5": 225,
  },
  {
    "4x6": 250,
  },
  {
    "4x7": 285,
  },
  {
    "4x8": 310,
  },
  {
    "4x9": 335,
  },
  {
    "4x10": 360,
  },
  {
    "4x11": 385,
  },
  {
    "4x12": 435,
  },
  {
    "5x1": 105,
  },
  {
    "5x2": 150,
  },
  {
    "5x3": 190,
  },
  {
    "5x4": 225,
  },
  {
    "5x5": 260,
  },
  {
    "5x6": 300,
  },
  {
    "5x7": 330,
  },
  {
    "5x8": 360,
  },
  {
    "5x9": 400,
  },
  {
    "5x10": 425,
  },
  {
    "5x11": 450,
  },
  {
    "5x12": 470,
  },
  {
    "6x1": 115,
  },
  {
    "6x2": 165,
  },
  {
    "6x3": 210,
  },
  {
    "6x4": 230,
  },
  {
    "6x5": 300,
  },
  {
    "6x6": 335,
  },
  {
    "6x7": 375,
  },
  {
    "6x8": 410,
  },
  {
    "6x9": 450,
  },
  {
    "6x10": 485,
  },
  {
    "6x11": 510,
  },
  {
    "6x12": 540,
  },
  {
    "7x1": 125,
  },
  {
    "7x2": 180,
  },
  {
    "7x3": 235,
  },
  {
    "7x4": 280,
  },
  {
    "7x5": 330,
  },
  {
    "7x6": 375,
  },
  {
    "7x7": 420,
  },
  {
    "7x8": 460,
  },
  {
    "7x9": 500,
  },
  {
    "7x10": 550,
  },
  {
    "7x11": 585,
  },
  {
    "7x12": 620,
  },
];
window.sticker3000Price = [
  {
    "1x1": 280,
  },
  {
    "1x2": 350,
  },
  {
    "1x3": 400,
  },
  {
    "1x4": 470,
  },
  {
    "1x5": 520,
  },
  {
    "1x6": 580,
  },
  {
    "1x7": 640,
  },
  {
    "1x8": 700,
  },
  {
    "1x9": 760,
  },
  {
    "1x10": 820,
  },
  {
    "1x11": 880,
  },
  {
    "1x12": 940,
  },
  {
    "2x1": 350,
  },
  {
    "2x2": 490,
  },
  {
    "2x3": 620,
  },
  {
    "2x4": 700,
  },
  {
    "2x5": 800,
  },
  {
    "2x6": 900,
  },
  {
    "2x7": 1000,
  },
  {
    "2x8": 1080,
  },
  {
    "2x9": 1200,
  },
  {
    "2x10": 1260,
  },
  {
    "2x11": 1320,
  },
  {
    "2x12": 1400,
  },
  {
    "3x1": 430,
  },
  {
    "3x2": 600,
  },
  {
    "3x3": 760,
  },
  {
    "2.75x2.15": 760,
  },
  {
    "3x4": 900,
  },
  {
    "3x5": 1050,
  },
  {
    "3x6": 1170,
  },
  {
    "3x7": 1330,
  },
  {
    "3x8": 1440,
  },
  {
    "3x9": 1550,
  },
  {
    "3x10": 1650,
  },
  {
    "3x11": 1750,
  },
  {
    "3x12": 1850,
  },
  {
    "3.68x2.24": 900,
  },
  {
    "4x1": 500,
  },
  {
    "4x2": 725,
  },
  {
    "4x3": 900,
  },
  {
    "3.5x2.5": 900,
  },
  {
    "4x4": 1100,
  },
  {
    "4x5": 1250,
  },
  {
    "4x6": 1450,
  },
  {
    "4x7": 1550,
  },
  {
    "4x8": 1750,
  },
  {
    "4x9": 1900,
  },
  {
    "4x10": 2000,
  },
  {
    "4x11": 2200,
  },
  {
    "4x12": 2500,
  },
  {
    "5x1": 550,
  },
  {
    "5x2": 800,
  },
  {
    "5x3": 1025,
  },
  {
    "5x4": 1250,
  },
  {
    "5x5": 1450,
  },
  {
    "5x6": 1700,
  },
  {
    "5x7": 1900,
  },
  {
    "5x8": 2050,
  },
  {
    "5x9": 2250,
  },
  {
    "5x10": 2450,
  },
  {
    "5x11": 2600,
  },
  {
    "5x12": 2700,
  },
  {
    "6x1": 600,
  },
  {
    "6x2": 900,
  },
  {
    "6x3": 1150,
  },
  {
    "6x4": 1450,
  },
  {
    "6x5": 1650,
  },
  {
    "6x6": 1900,
  },
  {
    "6x7": 2150,
  },
  {
    "6x8": 2300,
  },
  {
    "6x9": 2600,
  },
  {
    "6x10": 2800,
  },
  {
    "6x11": 2900,
  },
  {
    "6x12": 3000,
  },
  {
    "7x1": 650,
  },
  {
    "7x2": 1000,
  },
  {
    "7x3": 1300,
  },
  {
    "7x4": 1550,
  },
  {
    "7x5": 1850,
  },
  {
    "7x6": 2100,
  },
  {
    "7x7": 1800,
  },
  {
    "7x8": 2600,
  },
  {
    "7x9": 2900,
  },
  {
    "7x10": 3100,
  },
  {
    "7x11": 3350,
  },
  {
    "7x12": 3500,
  },
];
window.sticker10000Price = [
  {
    "1x1": 460,
  },
  {
    "1x2": 610,
  },
  {
    "1x3": 750,
  },
  {
    "1x4": 880,
  },
  {
    "1x5": 1000,
  },
  {
    "1x6": 1120,
  },
  {
    "1x7": 1240,
  },
  {
    "1x8": 1360,
  },
  {
    "1x9": 1470,
  },
  {
    "1x10": 1580,
  },
  {
    "1x11": 1700,
  },
  {
    "1x12": 1800,
  },
  {
    "2x1": 610,
  },
  {
    "2x2": 880,
  },
  {
    "2x3": 1120,
  },
  {
    "2x4": 1355,
  },
  {
    "2x5": 1575,
  },
  {
    "2x6": 1790,
  },
  {
    "2x7": 2000,
  },
  {
    "2x8": 2200,
  },
  {
    "2x9": 2395,
  },
  {
    "2x10": 2590,
  },
  {
    "2x11": 2700,
  },
  {
    "2x12": 2800,
  },
  {
    "3x1": 750,
  },
  {
    "3x2": 1125,
  },
  {
    "3x3": 1465,
  },
  {
    "2.75x2.15": 1465,
  },
  {
    "3x4": 1790,
  },
  {
    "3x5": 2100,
  },
  {
    "3x6": 2390,
  },
  {
    "3x7": 2685,
  },
  {
    "3x8": 2965,
  },
  {
    "3x9": 3240,
  },
  {
    "3x10": 3520,
  },
  {
    "3x11": 3850,
  },
  {
    "3x12": 4200,
  },
  {
    "3.68x2.24": 1780,
  },
  {
    "4x1": 880,
  },
  {
    "4x2": 1350,
  },
  {
    "4x3": 1780,
  },
  {
    "3.5x2.5": 1780,
  },
  {
    "4x4": 2200,
  },
  {
    "4x5": 2575,
  },
  {
    "4x6": 2960,
  },
  {
    "4x7": 3320,
  },
  {
    "4x8": 3725,
  },
  {
    "4x9": 4175,
  },
  {
    "4x10": 4610,
  },
  {
    "4x11": 5000,
  },
  {
    "4x12": 5500,
  },
  {
    "5x1": 1000,
  },
  {
    "5x2": 1580,
  },
  {
    "5x3": 2100,
  },
  {
    "5x4": 2590,
  },
  {
    "5x5": 3060,
  },
  {
    "5x6": 3525,
  },
  {
    "5x7": 4070,
  },
  {
    "5x8": 4620,
  },
  {
    "5x9": 5160,
  },
  {
    "5x10": 5700,
  },
  {
    "5x11": 6200,
  },
  {
    "5x12": 6700,
  },
  {
    "6x1": 1125,
  },
  {
    "6x2": 1790,
  },
  {
    "6x3": 2395,
  },
  {
    "6x4": 2965,
  },
  {
    "6x5": 3525,
  },
  {
    "6x6": 4180,
  },
  {
    "6x7": 4835,
  },
  {
    "6x8": 5490,
  },
  {
    "6x9": 6140,
  },
  {
    "6x10": 6800,
  },
  {
    "6x11": 7500,
  },
  {
    "6x12": 8000,
  },
  {
    "7x1": 1245,
  },
  {
    "7x2": 2000,
  },
  {
    "7x3": 2685,
  },
  {
    "7x4": 3330,
  },
  {
    "7x5": 4070,
  },
  {
    "7x6": 4835,
  },
  {
    "7x7": 5590,
  },
  {
    "7x8": 6360,
  },
  {
    "7x9": 7120,
  },
  {
    "7x10": 7885,
  },
  {
    "7x11": 8500,
  },
  {
    "7x12": 9200,
  },
];
